import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const detectIOStatusAPI = async (
  deviceId,
  deviceIds,
  spreadsheet,
  datetime,
  t,
  successfulText
) => {
  await axios({
    url: `/api/v2/command/io-status-detect-send`,
    method: "POST",
    data: {
      device_id: deviceId,
      device_ids: deviceIds,
      spreadsheet: spreadsheet,
      execute_type: "io_status_detect",
      execute_datetime: datetime
    }
  });
  successHandling(t, successfulText);
  return true;
};
